import { ChevronRight } from 'lucide-react'
import { useShell } from './shell-context'
import type { NavGroup } from './types'

type Crumb = { group: string; title: string }

function crumbFor(groups: NavGroup[], pathname: string): Crumb | null {
  let best: (Crumb & { url: string }) | null = null
  for (const group of groups) {
    for (const item of group.items) {
      const links = item.items
        ? item.items.map((child) => ({
            ...child,
            title: child.title,
          }))
        : [item]
      for (const link of links) {
        const url = String(link.url)
        const matches =
          url === '/'
            ? pathname === '/'
            : pathname === url || pathname.startsWith(`${url}/`)
        if (matches && (!best || url.length > best.url.length))
          best = { group: group.title, title: link.title, url }
      }
    }
  }
  return best
}

export function Breadcrumbs({ current }: { current?: string }) {
  const { groups, currentUrl, renderLink } = useShell()
  const pathname = currentUrl.split(/[?#]/)[0]
  const crumb = crumbFor(groups, pathname)
  const title = current ?? crumb?.title

  return (
    <nav
      aria-label="Breadcrumb"
      className="hidden min-w-0 items-center gap-2 text-sm md:flex"
    >
      {renderLink({
        to: '/',
        className:
          'shrink-0 text-muted-foreground transition-colors hover:text-foreground',
        children: 'Home',
      })}
      {title && (pathname !== '/' || current) ? (
        <>
          <ChevronRight className="size-3.5 shrink-0 text-muted-foreground/60" />
          <span className="truncate font-medium">{title}</span>
        </>
      ) : null}
    </nav>
  )
}
